import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { PageWrapper } from '@delab-team/de-ui';
import s from './layout.module.scss';
export const Layout = ({ children }) => (_jsx(PageWrapper, { className: s.wrapper, containerWidth: "500px", header: _jsx(_Fragment, {}), footer: _jsx(_Fragment, {}), pageTitle: "DeSim", content: _jsx("div", { className: s.content, children: children }) }));
